<template>
<div>
  <div style="height: 40px;margin: 10px 40px" v-if="tabs.length > 0">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
    <div class="add-open-btn" v-if="indexActive === 9 || indexActive === 12 || indexActive === 13 || indexActive === 25" @click="addOpen()">
      <strong>+</strong>
    </div>
  </div>
  <!--  子机列表  -->
  <div v-if="indexActive === 24" style="margin: 0 20px;height: 300px;padding-bottom: 20px">
    <el-table v-if="indexActive === 24" :data="subArr" ref="sub" border height="100%" style="width: 100%;font-size: 14px" highlight-current-row>
      <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
      <el-table-column label="子机名称" min-width="165" align="center">
        <template slot-scope="scope">
          <img style="width: 40px;height: 40px;vertical-align: middle" :src="scope.row.icon">
          <span style="vertical-align: middle">{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subdeviceid" label="子机编号" min-width="135" align="center"></el-table-column>
    </el-table>
  </div>
  <!--  电话本  -->
  <div v-if="indexActive === 9">
    <div class="content-info">
      <el-table v-if="indexActive === 9" ref="phoneTable" :data="phoneBookList" border style="width: 100%;" highlight-current-row size="mini">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="135" align="center"></el-table-column>
        <el-table-column prop="phone" label="电话" min-width="135" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="130">
          <template slot-scope="scope">
            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editPhoneBook(scope.row, scope.$index)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delPhoneBook(scope.row, scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <!--  白名单  -->
  <div v-if="indexActive === 10">
    <div style="height: 200px">
      <div style="height: 20px"></div>
      <div class="line-btn">
        <div class="btn-name">白名单开关</div>
        <div class="btn-text">
          <span style="color: #1A1A1A" v-if="whiteList !== ''">
            <span v-if="whiteList === '1'">关闭 - 拒接所有来电</span>
            <span v-if="whiteList === '2'">开启 - 电话本可以呼入</span>
            <span v-if="whiteList === '3'">只开启报警号码 - SOS号码可以呼入</span>
          </span>
          <span v-else>请设置白名单开关</span>
        </div>
        <div class="btn-arrow"><el-button type="primary" @click="openSetWhite">设置</el-button></div>
      </div>
    </div>
  </div>
  <!--  发送消息  -->
  <div v-if="indexActive === 11">
    <div style="height: 200px">
      <div style="height: 20px"></div>
      <div class="line-btn">
        <div class="btn-name">文字通知</div>
        <div class="btn-text">
          <span style="color: #1A1A1A" v-if="msgObj.content !== ''">
            <span v-if="msgObj.type === '1'">闪屏消息</span><span v-if="msgObj.type === '2'">普通消息</span>
            <span v-if="msgObj.type === '2'" style="margin-left: 6px">{{msgObj.title}}</span>
            <span style="margin-left: 6px">{{msgObj.content}}</span>
          </span>
          <span v-else>请设置文字通知</span>
        </div>
        <div class="btn-arrow"><el-button type="primary" @click="openSetMsg">设置</el-button></div>
      </div>
    </div>
  </div>
  <!--  SOS报警电话  -->
  <div v-if="indexActive === 12">
    <div class="content-info">
      <el-table v-if="indexActive === 12" :data="sosPhoneList" ref="sosPhoneTable" border style="width: 100%;" highlight-current-row size="small">
        <el-table-column type="index" label="序号" width="50" align="center" key="sosindex" v-if="indexActive === 12"></el-table-column>
        <el-table-column prop="phone" label="电话" min-width="135" align="center" key="sosphone" v-if="indexActive === 12"></el-table-column>
        <el-table-column align="center" label="操作" width="130" key="sos" v-if="indexActive === 12">
          <template slot-scope="scope">
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delSOSPhone310(scope.row, scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <!-- 701暂时设置一个sos号码 -->
  <div v-if="indexActive === 22">
    <div style="height: 160px">
      <div style="height: 20px"></div>
      <div class="line-btn">
        <div class="btn-text">
          <span style="color: #1A1A1A" v-if="sosPhoneList[0] && sosPhoneList[0].phone !== ''">
            <span>{{sosPhoneList[0].phone}}</span>
          </span>
          <span v-else>请设置SOS号码</span>
        </div>
        <div class="btn-arrow"><el-button type="primary" @click="openSetSos(sosPhoneList[0] ? sosPhoneList[0].phone : '')">设置</el-button></div>
      </div>
    </div>
  </div>
  <!--  310闹钟提醒  -->
  <div v-if="indexActive === 13" class="content-info">
    <el-table v-if="indexActive === 13" :data="clockList" ref="clockTable" border style="width: 100%;" highlight-current-row size="small">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="content" label="提醒内容" min-width="135" align="center"></el-table-column>
      <el-table-column label="提醒周期" min-width="135" align="center">
        <template slot-scope="scope">
          <span>{{showClockPeriod(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="提醒时间" min-width="135" align="center"></el-table-column>
      <el-table-column align="center" label="操作" width="130">
        <template slot-scope="scope">
          <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editClock(scope.row, scope.$index)"></i>
          <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delClock(scope.row, scope.$index)"></i>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <!--  311 313定时测量心率 定时测量血氧  -->
  <div v-if="indexActive === 14" style=" margin: 0 30px;">
    <el-row style="font-size: 18px">
      <el-col :span="12">
        <span>定时测量心率&nbsp;&nbsp;</span>
        <el-input placeholder="请输入" v-model="sethearttimer" style="width: 250px;">
          <template slot="append">分钟</template>
        </el-input>
      </el-col>
      <el-col :span="12">
        <span>定时测量血氧&nbsp;&nbsp;</span>
        <el-input placeholder="请输入" v-model="setoximetrytimer" style="width: 250px;">
          <template slot="append">分钟</template>
        </el-input>
      </el-col>
    </el-row>
    <div style="color: #f82a2a;margin-top: 10px">注：0为不设置定时测量。</div>
    <div style="height: 60px;margin: 30px 100px 0">
      <el-row>
        <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
        <el-col :span="12"><div class="send-btn" @click="submitSet313()"><span>确定</span></div></el-col>
      </el-row>
    </div>
  </div>
  <!--  407 752滞留时长  -->
  <div v-if="indexActive === 15">
    <el-form style="margin-right: 30px;margin-top: 10px" :model="zhiliuForm" :rules="zhiliuRules" ref="zhiliuForm" label-width="160px" class="demo-ruleForm">
      <el-form-item label="滞留预警时长" prop="time">
        <el-input placeholder="请输入" v-model="zhiliuForm.time" type="number" style="width: 350px">
          <template slot="append">分钟</template>
        </el-input>
        <span style="color: red">0为取消滞留预警设置。</span>
      </el-form-item>
      <el-row style="margin: 30px;height: 60px">
        <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
        <el-col :span="12"><div class="send-btn" @click="submitZhiliu('zhiliuForm')"><span>确定</span></div></el-col>
      </el-row>
    </el-form>
  </div>
  <!--  701 按键号码  -->
  <div v-if="indexActive === 23" style="height: 160px">
    <div style="height: 20px"></div>
    <div class="sos-phone" style="margin: 0 40px">
      <el-row>
        <el-col :span="12"><span>按键1号码&nbsp;&nbsp;</span><el-input type="number" style="width: 180px" placeholder="请输入" v-model="communityPhone.phone1"></el-input></el-col>
        <el-col :span="12"><span>按键2号码&nbsp;&nbsp;</span><el-input type="number" style="width: 180px" placeholder="请输入" v-model="communityPhone.phone2" clearable></el-input></el-col>
      </el-row>
    </div>
    <div style="height: 30px;margin: 30px 100px 0">
      <el-row>
        <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
        <el-col :span="12"><div class="send-btn" @click="submitCommunityPhone()"><span>确定</span></div></el-col>
      </el-row>
    </div>
  </div>
  <!--  定位设置  -->
  <div v-if="indexActive === 25" style="margin: 0 30px;height: 300px">
    <require-location :listObj="listObj" :locationCommand="locationCommand" ref="locationRef" @getCommandData="getDeviceCommand"></require-location>
  </div>
  <!--  佩戴设置  -->
  <div v-if="indexActive === 26" style="margin: 0 30px;">
    <div style="font-size: 16px;color: #1A1A1A;text-align: center">
      是否打开未佩戴报警：<el-switch v-model="switchAlarm" active-color="#17E5E5" inactive-color="#cccccc" active-value="1" inactive-value="0"></el-switch>
    </div>
    <div style="height: 60px;margin: 30px 100px 0">
      <el-row>
        <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
        <el-col :span="12"><div class="send-btn" @click="submitsetnotwear()"><span>确定</span></div></el-col>
      </el-row>
    </div>
  </div>
<!--  701无活动报警-->
  <div v-if="indexActive === 27" style="margin: 0 30px;">
    <no-activity :listObj="listObj" :commandObj="commandObj" ref="activity" @getCommandData="getDeviceCommand" @closeOpen="closeOpen"></no-activity>
  </div>
  <el-dialog :visible.sync="addEditWatchShow" v-if="addEditWatchShow" width="550px" :show-close="true" :close-on-click-modal="false"
             center append-to-body class="all-open">
    <div class="title-top-alarm">
      <div> <span>{{addEditWatchTitle}}</span> </div>
      <div class="line-title"></div>
      <div v-if="indexActive === 9">
        <el-form style="margin: 20px" size="small" :model="phoneForm" :rules="phoneRules" ref="phoneForm" label-width="70px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="phoneForm.name"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input type="number" v-model="phoneForm.phone"></el-input>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="addEditWatchShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitTelBook('phoneForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
      <div v-if="indexActive === 10">
        <el-form size="medium" style="text-align: left;margin: 20px;font-size: 18px" :model="whiteForm" :rules="whiteRules" ref="whiteForm" label-width="110px" class="demo-ruleForm">
          <el-form-item label="白名单开关" prop="type">
            <div><el-radio v-model="whiteForm.type" label="1">关闭 - <span>拒接所有来电</span></el-radio></div>
            <div><el-radio v-model="whiteForm.type" label="2">开启 - <span>电话本可以呼入</span></el-radio></div>
            <div><el-radio v-model="whiteForm.type" label="3">只开启报警号码 - <span>SOS号码可以呼入</span></el-radio></div>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="addEditWatchShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitWhite('whiteForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
      <div v-if="indexActive === 11">
        <el-form size="small" style="text-align: left;margin: 20px" :model="msgForm" :rules="msgRules" ref="msgForm" label-width="90px" class="demo-ruleForm">
          <el-form-item label="通知类型" prop="type">
            <el-radio-group v-model="msgForm.type">
              <el-radio label="1">闪屏消息</el-radio>
              <el-radio label="2" v-if="deviceRow.devicetype !== 701">普通消息</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="通知标题" prop="title" v-if="msgForm.type === '2'">
            <el-input v-model="msgForm.title"></el-input>
          </el-form-item>
          <el-form-item label="通知内容" prop="content">
            <el-input v-model="msgForm.content"></el-input>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="addEditWatchShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitMsg('msgForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
      <div v-if="indexActive === 12 || indexActive === 22">
        <el-form size="small" style="text-align: left;margin: 20px" :model="sosForm" :rules="sosRules" ref="sosForm" label-width="90px" class="demo-ruleForm">
          <el-form-item label="SOS号码" prop="phone">
            <el-input type="number" v-model="sosForm.phone"></el-input>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="addEditWatchShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitSOS('sosForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
      <div v-if="indexActive === 13">
        <el-form size="small" style="text-align: left;margin-top: 20px" :model="clockForm" :rules="clockRules" ref="clockForm" label-width="90px" class="demo-ruleForm">
          <el-form-item label="提醒内容" prop="content">
            <el-input v-model="clockForm.content"></el-input>
          </el-form-item>
          <el-form-item label="提醒周期" prop="period">
            <el-select v-fixZoom style="width: 100%" v-model="clockForm.period" placeholder="请选择" @change="changeTime">
              <el-option v-for="item in clockPeriodModelArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提醒时间" prop="time">
            <el-date-picker v-fixZoom v-if="clockForm.period === 'y'" v-model="clockForm.time" type="datetime"
              placeholder="选择日期时间" format="MM-dd HH:mm" value-format="MM-dd HH:mm:ss" style="width: 100%" default-time="08:00:00">
            </el-date-picker>
            <el-date-picker v-fixZoom v-if="clockForm.period === 'm'" v-model="clockForm.time" type="datetime"
              placeholder="请选择" format="dd HH:mm" value-format="dd HH:mm:ss" style="width: 100%" default-time="08:00:00">
            </el-date-picker>
             <el-time-picker v-fixZoom v-if="clockForm.period === 'd'" v-model="clockForm.time"
              placeholder="请选择" format="HH:mm" value-format="HH:mm:ss" style="width: 100%">
            </el-time-picker>
            <el-date-picker v-fixZoom v-if="clockForm.period === 's'" v-model="clockForm.time" type="datetime"
              placeholder="请选择" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" default-time="08:00:00">
            </el-date-picker>
            <div style="margin-left: 30px;color: #525151">
              <span v-if="clockForm.period === 'y'">月-日 时:分</span>
              <span v-if="clockForm.period === 'm'">日 时:分</span>
              <span v-if="clockForm.period === 'd'">时:分</span>
              <span v-if="clockForm.period === 's'">年-月-日 时:分</span>
            </div>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="addEditWatchShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitClock('clockForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {querycommand, sendcommand} from '../../../api/device'
import requireLocation from './requireLocation.vue'
import noActivity from './noActivity.vue'

export default {
  name: 'listTabsWatch310',
  components: {noActivity, requireLocation},
  model: {
    prop: 'listShow901',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      value: '',
      deviceRow: {
        devicetype: 0
      },
      tabs: [],
      indexActive: 1,
      // 9、电话本
      indexEdit: '',
      phoneBookList: [],
      phoneForm: {
        phone: '',
        name: ''
      },
      phoneRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' }
        ]
      },
      // 10、白名单
      whiteList: '',
      whiteForm: {
        type: ''
      },
      whiteRules: {
        type: [
          { required: true, message: '请选择', trigger: 'change' }
        ]
      },
      // 11、发送消息
      msgObj: {
        type: '1', // 1 闪屏消息。2 普通消息
        title: '',
        content: ''
      },
      msgForm: {
        type: '2', // 1 闪屏消息。2 普通消息
        title: '',
        content: ''
      },
      msgRules: {
        type: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入通知标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入通知内容', trigger: 'blur' }
        ]
      },
      // 12、SOS报警电话
      sosPhoneList: [],
      sosForm: {
        phone: ''
      },
      sosRules: {
        phone: [
          { required: true, message: '请输入号码', trigger: 'blur' }
        ]
      },
      // 13、闹钟提醒
      clockList: [], // 310
      clockForm: {
        id: '',
        period: 'y',
        time: '',
        content: ''
      },
      clockRules: {
        period: [
          { required: true, message: '请选择提醒周期', trigger: 'change' }
        ],
        time: [
          { required: true, message: '请选择提醒时间', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入提醒内容', trigger: 'blur' }
        ]
      },
      clockPeriodModelArr: [{name: '按年', id: 'y'}, {name: '按月', id: 'm'}, {name: '按天', id: 'd'}, {name: '只提醒一次', id: 's'}],
      // 弹窗
      addEditWatchShow: false,
      addEditWatchTitle: '',
      // 14
      sethearttimer: '',
      setoximetrytimer: '',
      // 15
      zhiliuForm: {time: ''},
      zhiliuRules: {
        time: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      // 23 701按键号码
      communityPhone: {
        phone1: '',
        phone2: ''
      },
      // 24 701子机列表
      subArr: [],
      // 25 定位
      locationCommand: '',
      // 26 是否打开未佩戴报警
      switchAlarm: '0', // 0 关闭 1 打开
      // 27 701无活动报警
      commandObj: {}
    }
  },
  created () {
    // 310 || 311 || 312 || 313 || 407 || 752 || 701
    this.deviceRow = this.clone(this.listObj.deviceRow)
    console.log('deviceRow', this.deviceRow)
    this.getTabs()
    this.getDeviceCommand()
    if (this.deviceRow.devicetype === 701) {
      this.getSubData()
    }
  },
  methods: {
    getSubData () {
      let info = this.deviceRow
      let arr = []
      let sub = []
      if (info.config !== '') {
        info.config = JSON.parse(info.config)
        while (typeof info.config === 'string') {
          info.config = JSON.parse(info.config)
        }
        info.config.forEach(item => {
          if (item.m === 'sub') {
            arr = item.v
          }
        })
      }
      console.log(info)
      console.log(arr)
      arr.forEach(item => {
        let obj = {name: '', icon: '', subdeviceid: ''}
        item.forEach(val => {
          if (val.m === 'model') {
            obj.name = this.getSubType(val.v)
            obj.icon = this.getSubIcon(val.v)
          }
          if (val.m === 'device-id') {
            obj.subdeviceid = val.v
          }
        })
        sub.push(obj)
      })
      this.subArr = sub
      console.log(sub)
    },
    getSubType (model) {
      let name = ''
      let subAll = this.commonType.getSubDevice701()
      subAll.forEach(sub => {
        if (sub.model === model) {
          name = sub.name
        }
      })
      return name
    },
    getSubIcon (model) {
      let icon = ''
      let subAll = this.commonType.getSubDevice701()
      subAll.forEach(sub => {
        if (sub.model === model) {
          icon = sub.icon
        }
      })
      return icon
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    getTabs () {
      console.log(11, this.deviceRow.devicetype)
      if (this.deviceRow.devicetype === 313) {
        this.tabs = [
          {index: 14, name: '设置心率血氧'},
          {index: 11, name: '发送消息'},
          {index: 25, name: '定位'}
        ]
        this.indexActive = 14
      } else if (this.deviceRow.devicetype === 311) {
        this.tabs = [
          {index: 12, name: 'SOS报警电话'},
          {index: 9, name: '电话本'},
          {index: 10, name: '白名单开关'},
          {index: 13, name: '闹钟提醒'},
          {index: 11, name: '发送消息'},
          {index: 14, name: '设置心率血氧'},
          {index: 25, name: '定位'},
          {index: 26, name: '佩戴设置'}
        ]
        this.indexActive = 12
      } else if (this.deviceRow.devicetype === 407 || this.deviceRow.devicetype === 752) {
        this.indexActive = 15
      } else if (this.deviceRow.devicetype === 701) {
        this.tabs = [
          {index: 24, name: '子机列表'},
          {index: 22, name: 'SOS号码'},
          {index: 23, name: '按键号码'},
          {index: 11, name: '发送消息'},
          {index: 27, name: '无活动报警'}
        ]
        this.indexActive = 24
      } else { // 310 312
        this.tabs = [
          {index: 12, name: 'SOS报警电话'},
          {index: 9, name: '电话本'},
          {index: 10, name: '白名单开关'},
          {index: 13, name: '闹钟提醒'},
          {index: 11, name: '发送消息'},
          {index: 25, name: '定位'},
          {index: 26, name: '佩戴设置'}
        ]
        this.indexActive = 12
      }
    },
    getDeviceCommand () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id
      }
      querycommand(data).then(res => {
        let vm = this
        let resDatas = res.data
        if (resDatas !== null) {
          for (let i = 0; i < resDatas.length; i++) {
            let resData = resDatas[i]
            let key = resData.key
            if (key === 'deviceset') {
            } else {
              let value = JSON.parse(resData.value)
              if (key === 'phonebook310') {
                // console.log(999, value.command1)
                let phones = value.command1.split(`&`)
                // console.log(phones)
                let phoneList = []
                phones.forEach(item => {
                  let phone = item.split('|')
                  let val = {
                    name: phone[0],
                    phone: phone[1],
                    url: phone[2],
                    imNum: phone[3]
                  }
                  phoneList.push(val)
                })
                vm.phoneBookList = phoneList
              } else if (key === 'sendmessage310') {
                let obj = {
                  type: value.command1,
                  title: value.command1 === '2' ? value.command2 : '',
                  content: value.command1 === '2' ? value.command3 : value.command2
                }
                this.msgObj = obj
              } else if (key === 'changealarmphone310') {
                if (value.command2 !== '') {
                  let sosphones = value.command2.split('|')
                  let list = []
                  sosphones.forEach(item => {
                    list.push({phone: item})
                  })
                  this.sosPhoneList = list
                } else {
                  if (value.command1 !== '') {
                    this.sosPhoneList.push({phone: value.command1})
                  }
                }
              } else if (key === 'setclock310') {
                let clocks = value.command1.split('|')
                let clockList = []
                clocks.forEach(item => {
                  let clock = item.split('#')
                  let val = {
                    id: clock[0],
                    period: clock[1],
                    time: clock[2],
                    content: clock[3]
                  }
                  clockList.push(val)
                })
                this.clockList = clockList
              } else if (key === 'whitelistswitch310') {
                this.whiteList = value.command1
              } else if (key === 'sethearttimer310') {
                this.sethearttimer = value.command1
              } else if (key === 'setoximetrytimer310') {
                this.setoximetrytimer = value.command1
              } else if (key === 'setstatus') {
                this.zhiliuForm.time = value.command2 !== '' ? parseFloat(value.command2) / 60 : ''
              } else if (key === 'community701') {
                this.communityPhone.phone1 = value.command1
                this.communityPhone.phone2 = value.command2
              } else if (key === 'requirelocationperiod310') {
                this.locationCommand = value.command1
                if (this.indexActive === 25) {
                  this.$refs.locationRef.getDeviceLocationData(value.command1)
                }
              } else if (key === 'setnotwear310') {
                this.switchAlarm = value.command1
              } else if (key === 'setisactivity') {
                this.commandObj = value
              }
            }
          }
        }
      }).catch(() => {})
    },
    changeTime () {
      this.clockForm.time = ''
    },
    showClockPeriod (row) {
      let result = ''
      if (row.period === 'y') {
        result = '按年'
      } else if (row.period === 'm') {
        result = '按月'
      } else if (row.period === 'd') {
        result = '按天'
      } else if (row.period === 's') {
        result = '只提醒一次'
      } else {
        result = row.period
      }
      return result
    },
    addOpen () {
      if (this.indexActive === 9) {
        this.phoneForm = { phone: '', name: '' }
        this.addEditWatchTitle = '添加电话'
        this.addEditWatchShow = true
      } else if (this.indexActive === 12) {
        this.sosForm = {phone: ''}
        this.addEditWatchTitle = '添加SOS报警电话'
        this.addEditWatchShow = true
      } else if (this.indexActive === 13) {
        this.clockForm = { id: '', period: 'y', time: '', content: '' }
        this.addEditWatchTitle = '添加闹钟'
        this.addEditWatchShow = true
      } else if (this.indexActive === 25) {
        this.$refs.locationRef.addLocation()
      }
    },
    openSetSos (phone) {
      this.sosForm = {phone: phone}
      this.addEditWatchTitle = '设置SOS号码'
      this.addEditWatchShow = true
    },
    editClock (row, index) {
      console.log(row)
      this.clockForm = { id: row.id, period: row.period, time: row.time, content: row.content }
      this.addEditWatchTitle = '编辑闹钟'
      this.indexEdit = index
      this.addEditWatchShow = true
    },
    delClock (row, index) {
      this.$confirm('此操作将永久删除该闹钟【' + row.time + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.addEditWatchTitle = '删除闹钟'
        this.indexEdit = index
        this.submitCommand310('setclock310')
      }).catch(() => {})
    },
    editPhoneBook (row, index) {
      this.phoneForm = { phone: row.phone, name: row.name }
      this.addEditWatchTitle = '编辑电话'
      this.indexEdit = index
      this.addEditWatchShow = true
    },
    delPhoneBook (row, index) {
      this.$confirm('此操作将永久删除该号码【' + row.phone + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.addEditWatchTitle = '删除电话'
        this.indexEdit = index
        this.submitCommand310('phonebook310')
      }).catch(() => {})
    },
    delSOSPhone310 (row, index) {
      let vm = this
      this.$confirm('此操作将永久删除该SOS号码【' + row.phone + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        console.log(1111)
        vm.addEditWatchTitle = '删除SOS报警电话'
        vm.indexEdit = index
        vm.submitCommand310('changealarmphone310')
      }).catch(() => {})
    },
    openSetWhite () {
      this.whiteForm.type = this.whiteList
      this.addEditWatchTitle = '设置白名单开关'
      this.addEditWatchShow = true
    },
    openSetMsg () {
      this.msgForm = { type: this.msgObj.type, title: this.msgObj.title, content: this.msgObj.content }
      this.addEditWatchTitle = '设置通知'
      this.addEditWatchShow = true
    },
    submitClock (formName) {
      console.log(this.clockForm.time + ':00')
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.clockForm.time = vm.clockForm.time + ':00'
          vm.submitCommand310('setclock310')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitSOS (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommand310('changealarmphone310')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitWhite (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommand310('whitelistswitch310')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitMsg (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommand310('sendmessage310')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitTelBook (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommand310('phonebook310')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitCommunityPhone () {
      this.submitCommand310('community701')
    },
    submitCommand310 (met) {
      // console.log(met, this.addEditWatchTitle, this.indexEdit)
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: met,
        command1: '',
        command2: '',
        command3: ''
      }
      let arr = []
      if (met === 'phonebook310') {
        arr = this.clone(this.phoneBookList)
        if (this.addEditWatchTitle === '添加电话') {
          arr.push(this.phoneForm)
        } else if (this.addEditWatchTitle === '编辑电话') {
          arr[this.indexEdit] = this.phoneForm
        } else if (this.addEditWatchTitle === '删除电话') {
          arr = arr.filter((item, i) => i !== this.indexEdit)
        }
        let command = ''
        // console.log(this.indexEdit, arr)
        arr.forEach(item => {
          if (command === '') {
            command = item.name + '|' + item.phone + '||'
          } else {
            command = command + '&' + item.name + '|' + item.phone + '||'
          }
        })
        data.command1 = command
      } else if (met === 'sendmessage310') {
        // msgForm
        data.command1 = this.msgForm.type
        data.command2 = this.msgForm.type === '2' ? this.msgForm.title : this.msgForm.content
        if (this.msgForm.type === '2') {
          data.command3 = this.msgForm.content
        }
      } else if (met === 'changealarmphone310') {
        arr = this.clone(this.sosPhoneList)
        if (this.addEditWatchTitle === '添加SOS报警电话') {
          arr.push(this.sosForm)
        } else if (this.addEditWatchTitle === '删除SOS报警电话') {
          arr = arr.filter((item, i) => i !== this.indexEdit)
        } else if (this.addEditWatchTitle === '设置SOS号码') {
          arr = [this.sosForm]
        }
        // console.log(arr)
        if (arr.length === 0) {
        } else if (arr.length === 1) {
          data.command1 = arr[0].phone
        } else {
          data.command1 = arr[0].phone
          let command2 = ''
          arr.forEach(sos => {
            if (command2 === '') {
              command2 = sos.phone
            } else {
              command2 = command2 + '|' + sos.phone
            }
          })
          data.command2 = command2
        }
      } else if (met === 'setclock310') {
        arr = this.clone(this.clockList)
        if (this.addEditWatchTitle === '添加闹钟') {
          arr.push(this.clockForm)
        } else if (this.addEditWatchTitle === '编辑闹钟') {
          arr[this.indexEdit] = this.clockForm
        } else if (this.addEditWatchTitle === '删除闹钟') {
          arr = arr.filter((item, i) => i !== this.indexEdit)
        }
        let command = ''
        for (let i = 0; i < arr.length; i++) {
          if (command === '') {
            command = (i + 1) + '#' + arr[i].period + '#' + arr[i].time + '#' + arr[i].content
          } else {
            command = command + '|' + (i + 1) + '#' + arr[i].period + '#' + arr[i].time + '#' + arr[i].content
          }
        }
        data.command1 = command
      } else if (met === 'whitelistswitch310') {
        data.command1 = this.whiteForm.type
      } else if (met === 'setstatus') {
        data.command1 = 'residence_time'
        data.command2 = parseFloat(this.zhiliuForm.time) * 60 + ''
      } else if (met === 'community701') {
        data.command1 = this.communityPhone.phone1
        data.command2 = this.communityPhone.phone2
      }
      sendcommand(data).then(res => {
        this.$notify({ title: '成功', message: '成功设置设备', type: 'success', duration: 2000 })
        if (met === 'phonebook310') {
          this.phoneBookList = arr
        } else if (met === 'sendmessage310') {
          this.msgObj = this.msgForm
        } else if (met === 'changealarmphone310') {
          this.sosPhoneList = arr
        } else if (met === 'setclock310') {
          this.clockList = arr
        } else if (met === 'whitelistswitch310') {
          this.whiteList = this.whiteForm.type
        } else if (met === 'setstatus') {
          this.closeOpen()
        }
        this.addEditWatchShow = false
        this.getDeviceCommand()
      }).catch(() => {})
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submitSet313 () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'sethearttimer310',
        command1: this.sethearttimer === '' ? '0' : this.sethearttimer + '',
        reserved2: this.deviceRow.devicetype + ''
      }
      sendcommand(data).then(res => {
        let data1 = {
          imei: this.deviceRow.deviceid,
          did: this.deviceRow.id,
          method: 'setoximetrytimer310',
          command1: this.setoximetrytimer === '' ? '0' : this.setoximetrytimer + '',
          reserved2: this.deviceRow.devicetype + ''
        }
        sendcommand(data1).then(res => {
          this.$notify({ title: '成功', message: '成功设置设备', type: 'success', duration: 2000 })
          this.getDeviceCommand()
        }).catch(() => {})
      }).catch(() => {})
    },
    submitsetnotwear () {
      let data1 = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'setnotwear310',
        command1: this.switchAlarm + ''
      }
      sendcommand(data1).then(res => {
        this.$notify({ title: '成功', message: '成功设置设备', type: 'success', duration: 2000 })
        this.getDeviceCommand()
      }).catch(() => {})
    },
    submitZhiliu (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommand310('setstatus')
        }
      })
    }
  }
}
</script>

<style scoped>
.sos-phone{
  color: #333333;
  font-size: 16px;
  letter-spacing: 1px;
}
.content-info{
  margin: 0 30px;
  height: 400px;
  overflow-y: auto;
  background-color: #FFFFFF;
}

.line-btn{
  height: 60px;
  background: #F2F2F2;
  border-radius: 6px 6px 6px 6px;
  margin: 0px 30px 0;
  display: flex;
}
.btn-name{
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  font-size: 22px;
  color: #1A1A1A;
  letter-spacing: 6px;
  padding: 0 30px;
}
.btn-text{
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  font-size: 22px;
  color: #9FA2AA;
  flex: 1;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
  white-space: nowrap;
}
.btn-arrow{
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.clock-item{
  height: 80px;
  font-size: 34px;
  color: #1A1A1A;
  display: flex;
  margin: 30px 30px 0;
}
.clock-type{
  width: 40px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #FFFFFF;
  font-size: 32px;
  border-radius: 6px;
}
.clock-type1{
  background: #6591FC;
}
.clock-type2{
  background: #FFA41D;
}
.lock-val{
  flex: 1;
  margin-left: 30px;
}
.clock-top{
  height: 50px;
  font-size: 34px;
  color: #1A1A1A;
}
.clock-time{
  height: 30px;
  font-size: 24px;
  color: #6A6A6A;
}
.clock-edit{
  width: 70px;
  height: 80px;
  line-height: 80px;
  color: #4578F6;
  font-size: 34px;
}
.clock-del{
  width: 70px;
  height: 80px;
  line-height: 80px;
  color: #ab3939;
  font-size: 34px;
}

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/listTabsWatch310.vue